(() => {
  if (window.__caimCartIntegrityListenerInstalled) return;
  window.__caimCartIntegrityListenerInstalled = true;
  let validationSequence = 0;

  function checkoutControls() {
    return document.querySelectorAll(
      '[name="checkout"], .cart__checkout-button, .additional-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify="accelerated-checkout"]'
    );
  }

  const messages = {
    duplicate: 'Revisa el carrito: cada inscripción CAIM debe aparecer una sola vez y con cantidad 1 antes de pagar.',
    prerequisites: 'Falta completar los datos o documentos de una inscripción. Entra en Mi Cuenta CAIM y completa su formulario antes de volver al carrito.',
    session: 'No hemos podido validar tu sesión. Entra de nuevo en Mi Cuenta CAIM con la cuenta vinculada a la inscripción y vuelve al carrito.',
    foreign: 'No hemos podido vincular alguna inscripción del carrito con tu cuenta familiar. Revisa Mi Cuenta CAIM o contacta con el club.',
    stale: 'La modalidad o cuota del carrito no coincide con la inscripción actual. Revisa la inscripción en Mi Cuenta CAIM y prepara de nuevo su compra.',
    malformed: 'No hemos podido identificar correctamente alguna inscripción del carrito. Revisa Mi Cuenta CAIM o contacta con el club.',
    technical: 'No hemos podido verificar el carrito en este momento. Recarga la página para volver a comprobarlo. Si continúa, contacta con el club.',
  };

  function cartError(reason) {
    return Object.assign(new Error('caim_cart_validation_failed'), { cartReason: reason });
  }

  function setIntegrityState(messageNodes, invalid, showMessage = invalid, reason = 'technical') {
    messageNodes.forEach((messageNode) => {
      if (showMessage) messageNode.textContent = messages[reason] || messages.technical;
      messageNode.hidden = !showMessage;
    });
    const messageIds = messageNodes.map((node) => node.id).filter(Boolean).join(' ');

    checkoutControls().forEach((control) => {
      if (invalid) {
        if (!control.matches('[data-caim-integrity-disabled="true"]') && !control.disabled) {
          control.dataset.caimIntegrityDisabled = 'true';
          control.dataset.caimIntegrityAriaDescribedby = control.getAttribute('aria-describedby') || '';
          control.setAttribute('disabled', 'disabled');
          control.setAttribute('inert', '');
          if (control.matches('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify="accelerated-checkout"]')) {
            control.hidden = true;
            control.setAttribute('aria-hidden', 'true');
          }
          if (messageIds) control.setAttribute('aria-describedby', messageIds);
        }
      } else if (control.dataset.caimIntegrityDisabled === 'true') {
        delete control.dataset.caimIntegrityDisabled;
        control.removeAttribute('disabled');
        control.removeAttribute('inert');
        control.hidden = false;
        control.removeAttribute('aria-hidden');
        const previousDescription = control.dataset.caimIntegrityAriaDescribedby;
        delete control.dataset.caimIntegrityAriaDescribedby;
        if (previousDescription) control.setAttribute('aria-describedby', previousDescription);
        else control.removeAttribute('aria-describedby');
      }
    });
  }

  function hasCaimCartLine() {
    return Boolean(cartSurface().querySelector('[data-caim-cart-line], [data-caim-enrollment-id], [data-caim-cart-has-line]'));
  }

  function cartSurface() {
    return document.querySelector('cart-items') || document;
  }

  function hasMalformedCaimCartLine() {
    return Boolean(cartSurface().querySelector('[data-caim-cart-malformed-line]'));
  }

  function cartEnrollmentLines(cart) {
    return (cart.items || []).filter((item) => {
      return Boolean(item.properties && Object.prototype.hasOwnProperty.call(item.properties, '_caim_enrollment_id'));
    });
  }

  async function validateAuthenticatedCaimLines(cart) {
    const lines = cartEnrollmentLines(cart).map((item) => ({
      enrollmentId: item.properties && item.properties._caim_enrollment_id,
      variantId: item.variant_id || item.id,
      sellingPlanId: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.id
        : item.selling_plan || null,
      quantity: item.quantity,
    }));
    const formData = new FormData();
    formData.set('intent', 'validate-family-cart');
    formData.set('cart_lines', JSON.stringify(lines));
    const response = await fetch('/apps/caim-inscripcion', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });
    if (response.status === 401 || response.status === 403) throw cartError('session');
    if (!response.ok) throw cartError('technical');
    const payload = await response.json();
    if (!payload || payload.ok !== true || payload.cartIntegrity?.valid !== true) {
      const issues = payload?.cartIntegrity?.issues;
      const reason = Array.isArray(issues)
        ? ['prerequisites', 'foreign', 'malformed', 'stale'].find((code) => issues.includes(code))
        : null;
      throw cartError(reason || 'technical');
    }
  }

  async function validateCart() {
    const requestSequence = ++validationSequence;
    const messageNodes = [...document.querySelectorAll('[data-caim-cart-integrity]')];
    const caimLineVisible = hasCaimCartLine();
    if (caimLineVisible) setIntegrityState(messageNodes, true, false);

    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart_lookup_failed');
      const cart = await response.json();
      if (requestSequence !== validationSequence) return;
      const ids = new Set();
      if (hasMalformedCaimCartLine()) {
        setIntegrityState(messageNodes, true, true, 'malformed');
        return;
      }
      const invalid = (cart.items || []).some((item) => {
        const enrollmentId = item.properties && item.properties._caim_enrollment_id;
        if (!enrollmentId) return false;
        if (item.quantity !== 1 || ids.has(enrollmentId)) return true;
        ids.add(enrollmentId);
        return false;
      });
      if (invalid) {
        setIntegrityState(messageNodes, true, true, 'duplicate');
        return;
      }
      if (cartEnrollmentLines(cart).length > 0) {
        await validateAuthenticatedCaimLines(cart);
        if (requestSequence !== validationSequence) return;
      }
      setIntegrityState(messageNodes, false);
    } catch (error) {
      if (requestSequence !== validationSequence) return;
      // Fail closed only for rendered CAIM lines. Normal merchandise can still
      // use checkout if Shopify's cart lookup is temporarily unavailable.
      setIntegrityState(messageNodes, hasCaimCartLine(), hasCaimCartLine(), error?.cartReason || 'technical');
    }
  }

  validateCart();
  document.addEventListener('cart:refresh', validateCart);
})();
